<template>
  <div class="animated fadeIn">
  </div>
</template>

<script>
export default {
  name: 'dashboard'
}
</script>



// WEBPACK FOOTER //
// src/views/Dashboard.vue